export default function LaserMarking() {
  const materials = [
    { icon: 'ri-tree-line', name: '나무' },
    { icon: 'ri-copper-coin-line', name: '금속' },
    { icon: 'ri-shirt-line', name: '가죽' },
    { icon: 'ri-box-3-line', name: '아크릴' },
    { icon: 'ri-gemstone-line', name: '원석' },
    { icon: 'ri-file-paper-line', name: '종이' }
  ];

  const applications = [
    '명패', '주차판', '표찰', '간판',
    '앨범', '다이어리', '스텐실', '우드포토', '차받침'
  ];

  return (
    <section className="py-20 px-4 bg-gradient-to-br from-slate-50 to-gray-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <div className="inline-flex items-center justify-center w-16 h-16 bg-slate-900 text-amber-500 rounded-full mb-6">
            <i className="ri-edit-box-line text-3xl"></i>
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-slate-900 mb-4">
            레이저 마킹 (각인)
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            다양한 재료에 정밀한 각인으로 특별한 가치를 더합니다
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-12">
          <div className="bg-white rounded-2xl p-8 shadow-lg">
            <h3 className="text-2xl font-bold text-slate-900 mb-6 flex items-center gap-3">
              <i className="ri-stack-line text-amber-500"></i>
              마킹 가능 재료
            </h3>
            <div className="grid grid-cols-3 gap-4">
              {materials.map((material, index) => (
                <div
                  key={index}
                  className="flex flex-col items-center gap-2 p-4 bg-gradient-to-br from-slate-50 to-gray-50 rounded-lg hover:shadow-md transition-shadow cursor-pointer"
                >
                  <div className="w-12 h-12 flex items-center justify-center bg-slate-900 text-amber-500 rounded-full">
                    <i className={`${material.icon} text-2xl`}></i>
                  </div>
                  <span className="text-sm font-semibold text-slate-900">{material.name}</span>
                </div>
              ))}
            </div>
          </div>

          <div className="bg-white rounded-2xl p-8 shadow-lg">
            <h3 className="text-2xl font-bold text-slate-900 mb-6 flex items-center gap-3">
              <i className="ri-lightbulb-line text-amber-500"></i>
              활용 분야
            </h3>
            <div className="flex flex-wrap gap-3">
              {applications.map((app, index) => (
                <span
                  key={index}
                  className="px-4 py-2 bg-gradient-to-br from-slate-50 to-gray-50 text-slate-900 text-sm font-medium rounded-full shadow-sm hover:shadow-md transition-shadow cursor-pointer"
                >
                  {app}
                </span>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
